export const SET_PARAMETERS = 'SET_PARAMETERS';
export const CLEAR_PARAMETERS = 'CLEAR_PARAMETERS';

export const setParametersReducer = parameters => ({
  type: SET_PARAMETERS,
  payload: parameters,
});

export const clearParametersReducer = () => ({
  type: CLEAR_PARAMETERS,
});

export const SET_CUSTOMER_CONFIG = 'SET_CUSTOMER_CONFIG';
export const CLEAR_CUSTOMER_CONFIG = 'CLEAR_CUSTOMER_CONFIG';

export const setCustomerConfigReducer = customerConfig => ({
  type: SET_CUSTOMER_CONFIG,
  payload: customerConfig,
});

export const clearCustomerConfigReducer = () => ({
  type: CLEAR_CUSTOMER_CONFIG,
});
